import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby';
import styled, { css } from 'styled-components';

import { getVariant } from 'utils';

const variants = {
  default: css`
    color: ${({ theme }) => theme.palette.blackLighten5};

    hr {
      background: ${({ theme }) => theme.palette.blueBase};
    }
    &:hover {
      color: ${({ theme }) => theme.palette.blueBase};

      hr {
        width: 100%;
      }
    }
  `,

  secondary: css`
    color: ${({ theme }) => theme.palette.whiteBase};

    &::after {
      content: '';
      border-bottom: 1px solid ${({ theme }) => theme.palette.navyGrayDarken15};
      left: 0;
      position: absolute;
      width: 100%;
      bottom: 0;
      pointer-events: none;
    }

    hr {
      background: ${({ theme }) => theme.palette.whiteBase};
    }
    &:hover {
      hr {
        width: 100%;
      }
    }
  `,

  tertiary: css`
    /* @TODO change color */
    color: #3a3a3a;
  `,
};

const StyledLink = styled(Link)`
  position: relative;
  text-decoration: none;
  font-weight: 400;
  z-index: 2;
  display: inline-block;

  font-size: 1.4rem;
  line-height: 2.4rem;

  ${({ size }) =>
    size === 'sm' &&
    css`
      font-size: 1.2rem;
      line-height: 1.6rem;
    `};

  ${({ size }) =>
    size === 'lg' &&
    css`
      font-size: 2rem;
      line-height: 3.2rem;

      ${({ theme }) => theme.breakpoints.maxTablet} {
        font-size: 1.6rem;
        line-height: 2.4rem;
      }
    `};

  hr {
    width: 0;
    height: 1px;
    position: absolute;
    border: 0;
    bottom: ${({ isHeader }) => (isHeader ? '-0.8rem' : 0)};
    z-index: 1;
    transition: all 0.2s ease-out;
    pointer-events: none;
  }

  ${getVariant(variants)}

  ${({ disabled }) =>
    disabled &&
    css`
      /* @TODO disabled color? */
      color: #9999ad;
      pointer-events: none;
    `};

  ${({ $active, $navlink }) =>
    $active &&
    $navlink &&
    css`
      color: ${({ theme }) => theme.palette.blueBase};

      hr {
        width: 100%;
      }
    `}
`;

const ButtonLink = ({ as, link, variant, size, href, isNavLink, isHeader }) => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line no-undef, no-restricted-globals
    if (location.pathname.includes(link.to)) {
      setIsActive(true);
    }
  }, []);

  return (
    <StyledLink
      as={as}
      to={link.to}
      href={href && href}
      variant={variant}
      size={size}
      disabled={link.disabled}
      $active={isActive}
      $navlink={isNavLink}
      isHeader={isHeader}
    >
      {link.name}
      <hr />
    </StyledLink>
  );
};
export default ButtonLink;
